import * as React from 'react';
import { useContext } from 'react';
import cn from 'classnames';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import MediaQuery from 'react-responsive';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../theme';
import { usePassengers } from '../../hooks';
import { OrderCardContext } from '../OrderCard';
import { useToggleable } from '../../../hooks';
import CommonItem from '../CommonItem/CommonItem';
import { PassengersDetailsModal } from '../../../PassengersDetails';

interface Props {
	className?: string;
	goToChangePassenger?: (passengerId: string) => void;
}

const OrderPassengers: React.FC<Props> = ({ className, goToChangePassenger }) => {
	const { OrderPassengers: css } = useTheme('OrderCard');
	const { t } = useTranslation('OrderCard');
	const { order, type } = useContext(OrderCardContext);
	const passengers = usePassengers(order);

	const { isOpen, open, close } = useToggleable(false);

	return (
		<>
			<CommonItem
				icon={'Info/Passengers'}
				type={type}
				text={
					<>
						<MediaQuery minWidth={MOBILE_MIN_WIDTH}>{t('Passengers')}: </MediaQuery>
						{passengers}
					</>
				}
				className={cn(css.root, className, {
					[css.account]: type === 'account'
				})}
				buttons={
					type === 'review' && (
						<span className={css.control} onClick={open}>
							{t('Details')}
						</span>
					)
				}
			/>

			{type === 'review' && (
				<PassengersDetailsModal
					isOpen={isOpen}
					onClose={close}
					orderId={order.id}
					orderStatus={order.status}
					travellers={order.travellers}
					changeTravellersAvailability={order.exareInfo?.changeTravellerDataAvailability}
					goToChangePassenger={goToChangePassenger}
				/>
			)}
		</>
	);
};

export default OrderPassengers;
